import { useMarque } from '@/hooks/useMarque';
import { cn } from '@/utils/cn';
import React from 'react';

interface LogoProps {
  className?: string;
  width?: number;
  height?: number;
  showText?: boolean;
}

export const Logo: React.FC<LogoProps> = ({
  className,
  width = 120,
  height = 40,
  showText = true,
}) => {
  // [C2 — marque blanche] Le logo est celui du cabinet quand il y en a un.
  // Sans cela, l'image d'Innov'Paie reste en haut de chaque écran d'une
  // plateforme censée porter le nom d'un autre.
  const marque = useMarque();

  if (!marque.parDefaut) {
    return (
      <div className={cn('flex items-center gap-3', className)}>
        {marque.logoUrl ? (
          <img
            src={marque.logoUrl}
            alt={marque.nomAffiche}
            className="w-auto object-contain"
            style={{ height: `${height}px`, maxWidth: `${width}px` }}
          />
        ) : (
          <span
            className="text-lg font-bold"
            style={{ color: 'var(--marque-accent)' }}
          >
            {marque.nomAffiche}
          </span>
        )}
      </div>
    );
  }

  return (
    <div className={cn('flex items-center gap-3', className)}>
      <img
        src="https://calendrier-production.innov-paie.fr/logo/colored_logo.png"
        alt="Innov' Paie"
        width={width}
        height={height}
        className="h-auto object-contain"
        style={{ width: `${width}px`, height: `${height}px` }}
      />
      {!showText && (
        <span className="text-xl font-bold text-neutral-900">Innov'Paie</span>
      )}
    </div>
  );
};
